import { defineRecipe } from "@chakra-ui/react/styled-system";

export default defineRecipe({
  base: {
    color: "colorPalette.fg",
  },
});
